//      
                                                    
import BaseTracker from "./BaseTracker";

export default class GTMTracker extends BaseTracker                     {
    constructor(trackingIds          , withEcommerce          = false, dealerId         = "unknown", dealerName         = "unknown", customerNo         = "unknown") {
        super(trackingIds[0], withEcommerce);

        if (navigator.doNotTrack === "1") {
            window[`ga-disable-${this.trackingId}`] = true;
            return;
        }

        this.injectGtag(this.trackingId, dealerId, dealerName, customerNo);
    }

    injectGtag(configId        , dealerId        , dealerName        , customerNo        ) {
        const existing = document.querySelector(`script[src*="gtag/js?id=${configId}"]`);
        if (!existing) {
            const script = document.createElement("script");
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(configId)}`;
            document.head.appendChild(script);
        }

        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function gtag() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };

        window.gtag("js", new Date());
        window.gtag("config", configId, {
            dealerId: dealerId,
            dealerName: dealerName,
            customerNo: customerNo
        });
    }

    handleGenericEvent(cat        , action        , label     )       {
        if (window && window.gtag) {
            window.gtag("event", action, {
                event_category: cat,
                event_label: label,
                event_source: "UCL"
            });
        }
    }

    handleOrderEvent(id        , revenue        )       {
        // volvo-selekt doesn't currently use order tracking in GTM
    }

    handleItemEvent(id        , name        , articleNumber        , price        )       {
        // volvo-selekt doesn't currently use item tracking in GTM
    }

    handleViewItemEvent(product     ) {
        if (window && window.gtag) {
            window.gtag("event", "view_item", {
                items: [{
                    item_id: product.id,
                    item_name: product.name,
                    price: product.price,
                }],
            });
        }
    }

    handleSearchEvent(searchTerm        ) {
        if (window && window.gtag) {
            window.gtag("event", "search", {
                search_term: searchTerm
            });
        }
        this.handleGenericEvent(searchTerm, searchTerm, searchTerm);
    }

    handleAddToCartEvent(product     ) {
        if (window && window.gtag) {
            window.gtag("event", "add_to_cart", {
                items: [{
                    item_id: product.id,
                    item_name: product.name,
                    price: product.price,
                }],
            });
        }
    }

    handleRemoveFromCartEvent(product     ) {
        if (window && window.gtag) {
            window.gtag("event", "remove_from_cart", {
                items: [{
                    item_id: product.id,
                    item_name: product.name,
                    price: product.price,
                }],
            });
        }
    }
}
